import Inputmask from 'inputmask';

export default {
    init() {
        $('.about_paypal').remove();

        let html = '';
        let html_option = '';
        let check = 'payment_method_';
        $('.wc_payment_method').each(function () {
            // Get array of class names
            let cls = $(this).attr('class').split(' ');

            let payment_method_input_value;
            for (let i = 0; i < cls.length; i++) {
                // Iterate over the class and log it if it matches
                if (cls[i].indexOf(check) > -1) {
                    let payment_method_label = '';
                    // Only the main gateway title (direct child label), not labels inside .payment_box
                    let titleLabel = $(this).children('label').first();
                    if (titleLabel.length && titleLabel.text().trim() !== '') {
                        payment_method_label = titleLabel.text().trim();
                        payment_method_input_value = $(this).find('input.input-radio').val();
                    }
                    html_option += '<option value="' + payment_method_input_value + '">' + payment_method_label + '</option>';
                }
            }
        });

        const inputMask = new Inputmask('999-999-9999');
        const billingPhone = document.getElementById('billing_phone');
        const shippingPhone = document.getElementById('shipping_phone');

        if (billingPhone) {
            inputMask.mask(billingPhone);
        }

        if (shippingPhone) {
            inputMask.mask(shippingPhone);
        }

        html += '<p class="form-row" id="payment-method"><select class="payment_method_select" style="display: block; width: 100%;">'+html_option+'</select></p>';
        $('.woocommerce-billing-fields .form-row:last').after(html);

        // Remember user's payment method so we can re-apply it after checkout fragment refresh (e.g. "ship to different address").
        let lastUserSelectedMethod = ($('.wc_payment_methods input.input-radio:checked').val() || null);

        function showPaymentBoxForMethod(paymentMethodId) {
            // Payment boxes are children of the ul: each li has .payment_box.payment_method_<id>
            $('#payment .payment_box').hide();
            const $box = $('#payment .payment_box.payment_method_' + paymentMethodId);
            if ($box.length) {
                $box.show();
            } else {
                // Fallback: show the .payment_box in the same li as the selected radio (e.g. after fragment refresh)
                $('#payment #payment_method_' + paymentMethodId).closest('.wc_payment_method').find('.payment_box').show();
            }
        }

        const placeOrderButtonBaseClass = 'button button--primary alt';

        function updatePlaceOrderButtonForMethod($radio) {
            const selectedMethod = $radio.val();
            const $btn = $('#payment .form-row.place-order').find('#place_order').first();
            if (!$btn.length) return;

            // When PayPal (redirect) is selected, keep the place order button hidden; the plugin uses .ppcp-hidden for this.
            if (selectedMethod === 'ppcp-gateway') {
                $btn.addClass('ppcp-hidden');
                $('#ppcp-hosted-fields #place_order').hide();
                return;
            }

            const orderButtonText = $radio.data('order_button_text') || $btn.data('value') || $btn.val();
            if (orderButtonText) {
                $btn.text(orderButtonText).val(orderButtonText).attr('data-value', orderButtonText);
            }
            $btn.removeClass(function (i, cls) {
                return (cls.match(/\bppcp-\S+/g) || []).join(' ');
            });
            $btn.addClass(placeOrderButtonBaseClass);
            $('#ppcp-hosted-fields #place_order').hide();
        }

        $('.payment_method_select').change(function () {
            let selected_payment_method = $(this).find(':selected').val();
            lastUserSelectedMethod = selected_payment_method;
            let $radio = $('.wc_payment_methods').find('#payment_method_'+selected_payment_method);

            $radio.prop('checked', true);
            // WooCommerce: trigger change so WC updates state
            $radio.trigger('change');
            // PayPal plugin: it toggles #place_order via .ppcp-hidden by listening for jQuery
            // "payment_method_selected" on document.body (not the input’s change). Trigger that
            // so it re-runs updateUi() and shows the place order button for card gateway.
            $(document.body).trigger('payment_method_selected');
            // Explicitly show this method’s .payment_box (child of the ul) so PayPal card fields appear
            showPaymentBoxForMethod(selected_payment_method);
            updatePlaceOrderButtonForMethod($radio);
        });

        // When WooCommerce refreshes the checkout fragment (e.g. "ship to different address" toggle),
        // it resets the payment method to the initial default. Re-apply the user's last selection if we have one.
        $(document.body).on('updated_checkout', function () {
            setTimeout(function () {
                const $select = $('.payment_method_select');
                let paymentMethodId = null;
                let $radio = null;

                if (lastUserSelectedMethod && $select.find('option[value="' + lastUserSelectedMethod + '"]').length) {
                    paymentMethodId = lastUserSelectedMethod;
                    $radio = $('.wc_payment_methods').find('#payment_method_' + paymentMethodId);
                }
                if (!paymentMethodId || !$radio.length) {
                    $radio = $('.wc_payment_methods input.input-radio:checked');
                    if (!$radio.length) return;
                    paymentMethodId = $radio.val();
                }

                $radio.prop('checked', true);
                $radio.trigger('change');
                if ($select.find('option[value="' + paymentMethodId + '"]').length) {
                    $select.val(paymentMethodId);
                }
                $(document.body).trigger('payment_method_selected');
                updatePlaceOrderButtonForMethod($radio);
                // Show the correct .payment_box (description + fields) last so nothing overwrites it
                showPaymentBoxForMethod(paymentMethodId);
            }, 0);
        });

        // Sync dropdown and UI to the server’s default (checked radio) on load
        (function initPaymentSync() {
            const $radio = $('.wc_payment_methods input.input-radio:checked');
            if (!$radio.length) return;
            const paymentMethodId = $radio.val();
            const $select = $('.payment_method_select');
            if ($select.find('option[value="' + paymentMethodId + '"]').length) {
                $select.val(paymentMethodId);
            }
            showPaymentBoxForMethod(paymentMethodId);
            $(document.body).trigger('payment_method_selected');
            updatePlaceOrderButtonForMethod($radio);
        })();
    },
};

////////////////////////////////
// Change select first option //
////////////////////////////////
// var select = $('select[data-placeholder]')
//
// select.each(function() {
//     var select_placeholder = select.data('placeholder');
//     var first_option = $(this).find('option:eq(0)');
//     first_option.html(select_placeholder);
// });
//
//
// $('.single-product').each(function() {
//     var this_product = $(this);
//     var this_product_fabric = this_product.find('[data-attribute-type="fabric"] [data-swatch].active').data('swatch-title');
//     var this_product_nailhead = this_product.find('[data-attribute-type="nailhead"] [data-swatch].active').data('swatch-title');
//
//     var product_var_text = this_product_fabric;
//     if (this_product_nailhead) {
//         product_var_text += ' + '+ this_product_nailhead;
//     }
//     this_product.find('.product_variation').text(product_var_text);
// });

///////////////////////////////////////////////
// Fade out and in chair on variation change //
///////////////////////////////////////////////
// $('[data-swatch]').bind('click', function() {
//     const this_swatch = $(this);
//     const this_product = this_swatch.parents('.single-product');
//
//     this_swatch.siblings('[data-swatch]').removeClass('active');
//     this_swatch.addClass('active');
//
//
//     const this_product_fabric = this_product.find('[data-attribute-type="fabric"] [data-swatch].active').data('swatch-title');
//     const this_product_nailhead = this_product.find('[data-attribute-type="nailhead"] [data-swatch].active').data('swatch-title');
//     const this_image_wrapper = this_product.find('.woocommerce-product-gallery__image');
//
//     var product_var_text = this_product_fabric;
//
//     if (this_product_nailhead) {
//         product_var_text += ' + '+ this_product_nailhead;
//     }
//     this_product.find('.product_variation').text(product_var_text);
//
//     this_image_wrapper.animate({opacity: 0}, 200, function() {
//         this_product
//             .find( '.variations option[value="'+this_swatch.data('swatch')+'"]' )
//             .prop('selected', true)
//             .trigger('change');
//
//         this_image_wrapper.find('img').on( 'load', function() {
//             this_image_wrapper.animate({opacity: 1}, 200);
//         });
//     });
// });


// var active_chair_id = $('[data-active-chair]').data('active-chair');
//
// if (! active_chair_id) {
//     const first_product = $('.products .product:first');
//     first_product.addClass('active');
//     active_chair_id = first_product.find('[data-product_id]').data('product_id');
//     $('.single-product').find('#product-'+active_chair_id).parent().addClass('active');
// } else {
//     $('.single-product').find('#product-'+active_chair_id).parent().addClass('active');
//
//     setTimeout(function() {
//         $('html, body').delay(400).animate({
//             scrollTop: $('.single-product.active').parent().offset().top - 110
//         }, 1000);
//     }, 400);
// }

// $('[data-product_id]').siblings('.woocommerce-LoopProduct-link').bind('click', function() {
//     var product_id = $(this).siblings('[data-product_id]').data('product_id');
//     $('.product').removeClass('active');
//     $(this).parent().addClass('active');
//
//     $('.single-product').fadeOut(400).removeClass('active');
//
//     $('.single-product').find('#product-'+product_id).parent().fadeIn(400).addClass('active');
//
//     setTimeout(function() {
//         $('html, body').delay(400).animate({
//             scrollTop: $('.single-product.active').parent().offset().top - 110
//         }, 1000);
//     }, 400);
//
//     return false;
// });



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js